module.exports = __webpack_public_path__ + "static/media/inProcess.af0644dd.svg";